import * as React from 'react';
import style from './MixedInFrom.scss';
import { Text } from '../../../PageElements/Text';
import { getTypesElements } from '../utils';
import { LoggerContext } from '../../../../appContext/LoggerProvider';
import { StoreContext } from '../../../../appContext/StoreProvider';

export const MixedInFrom = ({ items = [] }) => {
  const { logger } = React.useContext(LoggerContext);
  const { store } = React.useContext(StoreContext);
  return (
    <div className={style.inheritedProps}>
      <Text weight="bold" dataHook="title" tagName="span">
        Mixed in from:
      </Text>
      {getTypesElements(items, logger, store)}
    </div>
  );
};
